// extracted by mini-css-extract-plugin
export default {"statisticsMobile":"StatisticsMobile_statisticsMobile__NlNLs","statistics-header":"StatisticsMobile_statistics-header__ro8AS"};